import {
  Snackbar as MuiSnackbar,
  SnackbarProps,
  SnackbarContent as MuiSnackbarContent,
  SnackbarContentProps,
} from "@mui/material";
import { withDisplayName } from "../../utils/displayName";

const Snackbar = withDisplayName(MuiSnackbar, "Snackbar");
const SnackbarContent = withDisplayName(MuiSnackbarContent, "SnackbarContent");

export type { SnackbarProps, SnackbarContentProps };
export { Snackbar, SnackbarContent };
